function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMccGoods = function SvgMccGoods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Zm0 9h32v17a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V14Zm10 7a2 2 0 0 1 2-2h8a2 2 0 1 1 0 4h-8a2 2 0 0 1-2-2Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccGoods;